import { render, staticRenderFns } from "./RinvPT_Items.vue?vue&type=template&id=645f7a12"
import script from "./RinvPT_Items.vue?vue&type=script&lang=js"
export * from "./RinvPT_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports